export type PlannerEventStatus =
  | 'Pending'
  | 'New request'
  | 'Under review'
  | 'Confirmed'
  | 'Declined'
  | 'Request for cancellation'
  | 'Cancelled'
  | 'Completed'
  | 'Did not occur';

export interface EventOwner {
  name: string;
  email?: string;
  avatarUrl?: string;
}

export interface OwnerOption {
  id: string;
  displayName: string;
}

export const UNASSIGNED_OWNER_ID = 'UNASSIGNED';

export interface PlannerEventRow {
  eventId: string;
  eventName: string;
  referenceId: string;
  buildingId: string;
  buildingName: string;
  conferenceRoom: string;
  additionalRooms: string[];
  requestedBy: string;
  fteSponsor: string;
  submittedDate: string;
  submittedDateRaw: string;
  eventDate: string;
  eventDateRaw: string;
  status: PlannerEventStatus;
  owner: EventOwner;
  attendeeType: string;
  ageDays: number;
}

export type FilterCategory = 'owner' | 'status' | 'building' | 'submittedDate' | 'eventDate';

export interface EventFilters {
  owners: string[];
  statuses: PlannerEventStatus[];
  buildings: string[];
  submissionStartDate: Date | null;
  submissionEndDate: Date | null;
  eventStartDate: Date | null;
  eventEndDate: Date | null;
}

export interface EventReviewEditInput {
  stateProvince: string;
  startDate: string;
  endDate: string;
  startTime?: string;
  endTime?: string;
  attendees: string;
  roomSetupCodes?: string[];
  attendeeType: string;
  businessPurpose: string;
  businessGroupCode?: string;
  businessJustification?: string;
  additionalInformation?: string;
  ioCcNumber: string;
  hasOnSiteContact: boolean;
  onSiteContacts: { name: string; email: string }[];
  hasCatering: boolean;
  filmingRequired: boolean;
  overnightStorage: boolean;
  shipments: boolean;
  sponsorName?: string;
  sponsorEmail?: string;
}

export interface FilterPillData {
  category: FilterCategory;
  label: string;
  displayValue: string;
}

export const EMPTY_FILTERS: EventFilters = {
  owners: [],
  statuses: [],
  buildings: [],
  submissionStartDate: null,
  submissionEndDate: null,
  eventStartDate: null,
  eventEndDate: null,
};

export interface Planner {
  id: string;
  displayName: string;
  email: string;
}

export type BulkActionType = 'claim' | 'handoff';

export interface BulkActionResult {
  success: boolean;
  processedCount: number;
  failedCount: number;
  errorMessage?: string;
}
